import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksQualityNorms(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORMS,
        options
    )
}

function _getWorksQualityNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORM,
        options
    )
}

function _createWorksQualityNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].CREATE_WORKS_QUALITY_NORM,
        options
    )
}

function _putWorksQualityNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PUT_WORKS_QUALITY_NORM,
        options
    )
}

function _patchWorksQualityNorms(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PATCH_WORKS_QUALITY_NORMS,
        options
    )
}

function _deleteWorksQualityNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_QUALITY_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].DELETE_WORKS_QUALITY_NORM,
        options
    )
}

export default {
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORMS]: _getWorksQualityNorms,
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].GET_WORKS_QUALITY_NORM]: _getWorksQualityNorm,
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].CREATE_WORKS_QUALITY_NORM]: _createWorksQualityNorm,
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PUT_WORKS_QUALITY_NORM]: _putWorksQualityNorm,
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].PATCH_WORKS_QUALITY_NORMS]: _patchWorksQualityNorms,
    [ModulesConfigMap[ModulesMap.WORKS_QUALITY_NORMS].DELETE_WORKS_QUALITY_NORM]: _deleteWorksQualityNorm,
}